module.exports = __webpack_public_path__ + "img/rayscom-blue.867ae531.svg";